<template>
  <div class="container">
    <van-nav-bar
      title="选择科目"
      left-arrow
      @click-left="goBackFn"
      class="fixedtop"
    />
    <div class="order_list" :data="mycollect" v-if="mycollect.length != 0">
      <div
        class="result_all"
        v-for="(item, index) in mycollect"
        :key="index"
        @click.stop="goDetails(item.id)"
      >
        <img :src="item.image" class="big__imgs" alt="" />
        <div class="down_boxs">
          <div class="title_two t_text">
            {{ item.examname }}
          </div>
          <div class="sou_one">
            <span class="shi_name_one">所需课时：</span>
            <span class="xu_name_one">{{ item.class_hour }}课时</span>
          </div>
          <div class="down_keshi">
            <div class="suo_xu">
              <span class="shi_name">已完成课时：</span>
              <span class="xu_name">{{ item.finish_hour }}课时</span>
            </div>
            <div class="suo_x2 suo_xu">
              <span class="shi_name">截止日期：</span>
              <span class="xu_name">{{ item.expirationtime }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="nomore == true" class="no_more">没有更多了</div>
    </div>
    <div class="empty" v-else>
      <img
        src="../../assets/image/jin_09.png"
        v-if="it_cloose == true"
        class="emptyimg"
        alt
      />
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
  name: "mycollect",
  data() {
    return {
      mycollect: [],
      nomore: false,
      it_cloose: false,
      total: 0,
      reqParams: {
        page: 0,
        pageNum: 10
      }
    };
  },
  created() {
    this.getMycollect();
    let that = this
    window.onscroll = function () {
      // scrollTop 滚动条滚动时，距离顶部的距离
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      // windowHeight 可视区的高度
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      // scrollHeight 滚动条的总高度
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      // 滚动条到底部的条件
      if (scrollTop + windowHeight >= scrollHeight) {
        // 加载数据
        if (that.total != that.mycollect.length) {
          that.getMycollect();
        } else {
          that.nomore = true
        }
      }
    }
  },
  methods: {
    goBackFn() {   // 回到上一步
      window.localStorage.removeItem('jin-token')
      this.$router.go(-1);
    },
    goDetails(id) {
      this.$router.push({ path: '/home', query: { id: id } })
    },
    async getMycollect() {  // 获取课程
      this.reqParams.page++
      try {
        const {
          data: { data }
        } = await this.postRequest("api/lists/mobileStudy", this.reqParams);
        // console.log(data);
        this.mycollect = this.mycollect.concat(data.info);
        this.total = data.total_num
        if (this.mycollect.length == 0) {
          this.it_cloose = true;
        }

      } catch (err) {
        Toast.fail(err.msg)
        // console.log(err);
      }

    },

  }
};
</script>

<style scoped lang='less'>
.container {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .fixedtop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
  }
  .order_list {
    width: 100%;
    padding: 70px 16px 16px;
    box-sizing: border-box;
    background-color: #f5f5f5;
    min-height: 100%;

    .result_all {
      width: 100%;
      border-radius: 8px;
      background-color: #fff;
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      margin-bottom: 12px;

      .big__imgs {
        width: 100%;
        height: 186px;
      }

      .down_boxs {
        width: 100%;
        padding: 13px 16px 16px;
        box-sizing: border-box;

        .title_two {
          width: 100%;
          font-size: 16px;
          font-family: Source Han Sans CN, Source Han Sans CN-Medium;
          font-weight: 600;
          text-align: left;
          color: #06121e;
          line-height: 24px;
        }
        .sou_one {
          width: 100%;
          display: flex;
          align-items: center;
          height: 24px;
          margin-top: 5px;

          .shi_name {
            font-size: 12px;
            font-family: Source Han Sans CN, Source Han Sans CN-Regular;
            font-weight: 400;
            text-align: left;
            color: #06121e;
          }
          .xu_name_one {
            font-size: 12px;
            font-family: Source Han Sans CN, Source Han Sans CN-Regular;
            font-weight: 400;
            text-align: left;
            color: #8c9198;
          }
        }

        .down_keshi {
          width: 100%;
          display: flex;
          align-items: center;

          .suo_xu {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .shi_name {
              font-size: 12px;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;
              font-weight: 400;
              text-align: left;
              color: #06121e;
              line-height: 24px;
            }
            .xu_name {
              font-size: 12px;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;
              font-weight: 400;
              text-align: left;
              color: #8c9198;
              line-height: 24px;
            }
          }
          .suo_x2 {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-end;
          }
        }
      }
    }
    .currentpae {
      // width: 100%;
      padding: 0 16px;
      box-sizing: border-box;
      background-color: #f9f9f9;
    }
  }

  .no_more {
    width: 100%;
    padding: 20px 0;
    box-sizing: border-box;
    text-align: center;
    font-size: 14px;
    color: #5d5d5d;
  }

  .empty {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 150px;
    box-sizing: border-box;
    .emptyimg {
      width: 100px;
      height: 100px;
    }
  }
}
</style>